<template>
  <div :class="customer">
    <a :href="data.filePath">
      <img src="../assets/file.png" width="24" height="24">
      {{data.Text}}
    </a>
    <br>
  </div>
</template>

<script>
import Global from "@/components/Global";
export default {
  props: ["data"],
  computed: {
    customer() {    
      let result = false;
      result = this.data.senderType === 1;
      return result
        ? "message my-message"
        : "message other-message float-right";
    },
  }
};
</script>





// WEBPACK FOOTER //
// src/components/FileMessage.vue